export default __webpack_public_path__ + "static/media/symbols.74d342c4.svg";